import { getButtonFocusOverrideStyle } from '@bingads-webui-campaign-react/main-menu';

export const getUetTagItemStyles = (menuItem, { palette = {} }) => ({
  baseMenuItem: {
    height: 36,
    fontFamily: 'Segoe UI',
    fontWeight: 'normal',
    lineHeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 20,
    paddingRight: 10,
    border: 0,
    textDecoration: 'none',
    color: '#f3f2f1',
    backgroundColor: '#f3f2f1',
    alignItems: 'center',
    textAlign: 'left',
    borderRadius: 'unset',
    // menu item is using Button, but states' style should not act the same as Button.
    '& a': {
      color: palette.white,
    },
    '&:focus': getButtonFocusOverrideStyle(palette.neutralSecondary),
    '&:active': {
      '&:focus': {
        '&:after': {
          border: 0,
        },
      },
    },
    '& .spinner_label': {
      color: palette.white,
    },
  },
  normalMenuItem: {
    backgroundColor: '#f3f2f1 !important',
    '&:focus': {
      backgroundColor: palette.neutralLight,
      fontWeight: 'bold',
    },
    '&:hover': {
      backgroundColor: palette.neutralLight,
      fontWeight: 'bold',
    },
  },
  selectedMenuItem: {
    paddingLeft: 16,
    fontWeight: 'bold',
    backgroundColor: '#DEECF9 !important',
    borderLeft: `4px solid ${palette.themePrimary}`,
    alignSelf: 'stretch',
  },
  menuItemAnchor: {
    width: '98px',
    marginTop: 3,
  },
  iconContainer: {
    marginLeft: 8,
    marginTop: 2,
    marginBottom: 6,
    marginRight: 8,
    height: 16,
    fontSize: 16,
    color: palette.white,
  },
  textContainer: {
    display: 'inline-block',
    width: '100px',
    overflow: 'hidden',
    marginTop: 8,
    marginBottom: 9,
    textOverflow: 'ellipsis',
    flex: '1 1 1px',
    whiteSpace: 'nowrap',
    fontSize: 14,
    color: 'black',
  },
  typeSelectionIcon: {
    fontSize: 16,
    margin: '0px !important',
    top: '0px !important',
  },
  placeholderTextContainer: {
    marginLeft: 22,
  },
});
